var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c("div", { staticClass: "details-view" }, [
        _c(
          "div",
          {
            staticClass: "section",
            staticStyle: {
              height: "100%",
              padding: "0 5px",
              display: "flex",
              "flex-direction": "row"
            }
          },
          [
            _c("cargo-ag-grid", {
              class: _vm.isPreview || _vm.isEdit ? "not-click" : "",
              staticStyle: {
                flex: "0 0 auto",
                width: "200px",
                margin: "5px 0"
              },
              attrs: {
                "grid-options": _vm.gridOptions,
                "row-data": _vm.rowData,
                "show-side-bar": false
              }
            }),
            _c("div", {
              staticStyle: {
                flex: "0 0 auto",
                width: "2px",
                margin: "0 5px",
                background: "#DCDFE6"
              }
            }),
            _c(
              "div",
              {
                staticClass: "main-content",
                staticStyle: {
                  "flex-grow": "1",
                  height: "auto",
                  margin: "5px 0"
                }
              },
              [
                _c("div", { staticClass: "operations" }, [
                  _c("div", { staticClass: "triggers" }, [
                    !!_vm.moduleRow
                      ? _c(
                          "div",
                          { staticStyle: { "padding-left": "15px" } },
                          [
                            [
                              _c(
                                "span",
                                { staticStyle: { "margin-right": "8px" } },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.opOffice")))]
                              ),
                              _c(
                                "el-select",
                                {
                                  attrs: { filterable: "" },
                                  model: {
                                    value: _vm.branchId,
                                    callback: function($$v) {
                                      _vm.branchId = $$v
                                    },
                                    expression: "branchId"
                                  }
                                },
                                _vm._l(_vm.officeList, function(item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: _vm.getOfficeLabel(item),
                                      value: item.officeId
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            _vm.moduleRow.enableInstruction
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.editOpInstructionDialog }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SystemMaintenance.SetOpInstruction"
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm.moduleRow.module === _vm.SEA_BOOKING_MODULE
                              ? _c(
                                  "el-button",
                                  {
                                    key: "valueSync",
                                    attrs: { type: "primary" },
                                    on: { click: _vm.showValueSyncSetDialog }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SystemMaintenance.SetFieldValueSynchronization"
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      : _vm._e(),
                    !!_vm.validateRow
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-left": "5px",
                              "margin-bottom": "5px"
                            }
                          },
                          [
                            _vm.isPreview && !_vm.validateRow.disableCustomPage
                              ? [
                                  _c(
                                    "el-button",
                                    {
                                      key: "back",
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          _vm.isPreview = false
                                          _vm.previewConfig = null
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("CargoMsg.Cargo_Back"))
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            !_vm.isPreview && !_vm.validateRow.disableCustomPage
                              ? [
                                  _vm.readonly
                                    ? [
                                        _c(
                                          "el-button",
                                          {
                                            key: "edit",
                                            attrs: {
                                              disabled:
                                                _vm.branchId !== 1 &&
                                                _vm.useHqSet,
                                              type: "primary"
                                            },
                                            on: { click: _vm.onEdit }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("Message.Edit"))
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            key: "readPreview",
                                            attrs: { type: "primary" },
                                            on: { click: _vm.onPreview }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("CargoMsg.Cargo_Preview")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            key: "opOffice",
                                            staticStyle: { margin: "0px 8px" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("SeaExport.opOffice")
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    : [
                                        _c(
                                          "el-button",
                                          {
                                            key: "save",
                                            attrs: { type: "success" },
                                            on: { click: _vm.onSave }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("CargoMsg.Cargo_Save")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            key: "cancel",
                                            attrs: { type: "success" },
                                            on: { click: _vm.onCancel }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("Message.Cancel"))
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            key: "editPreview",
                                            attrs: { type: "primary" },
                                            on: { click: _vm.onPreview }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("CargoMsg.Cargo_Preview")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            key: "reset",
                                            attrs: {
                                              disabled:
                                                _vm.branchId !== 1 &&
                                                _vm.useHqSet,
                                              type: "warning"
                                            },
                                            on: { click: _vm.onReset }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("Message.Reset"))
                                            )
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            key: "branchCMP",
                                            staticStyle: { margin: "0px 8px" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "CargoMsg.Cargo_BranchCMP"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        disabled: _vm.isEdit,
                                        filterable: ""
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.loadData()
                                        }
                                      },
                                      model: {
                                        value: _vm.branchId,
                                        callback: function($$v) {
                                          _vm.branchId = $$v
                                        },
                                        expression: "branchId"
                                      }
                                    },
                                    _vm._l(_vm.officeList, function(
                                      item,
                                      index
                                    ) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: _vm.getOfficeLabel(item),
                                          value: item.officeId
                                        }
                                      })
                                    }),
                                    1
                                  ),
                                  _c(
                                    "span",
                                    { staticStyle: { margin: "0 5px 0 10px" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_GeneralSettings"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _c("el-checkbox", {
                                    staticStyle: { "margin-right": "10px" },
                                    attrs: {
                                      value: _vm.useHqSet,
                                      disabled: _vm.isEdit
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.onUseHqSetInput(
                                          !_vm.useHqSet
                                        )
                                      }
                                    }
                                  }),
                                  _vm.branchId !== 1
                                    ? _c("span", [
                                        _c("i", {
                                          staticClass: "el-icon-warning",
                                          staticStyle: {
                                            color: "#e6a23c",
                                            "font-size": "14px"
                                          }
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "SystemMaintenance.HQSettingNotEditAlias"
                                              )
                                            ) +
                                            " "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm.readonly &&
                                  _vm.fieldPermissionCanPageTypes.includes(
                                    _vm.validateRow.pageType
                                  ) &&
                                  _vm.enableUICustomFieldPermissioin
                                    ? [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "primary" },
                                            on: {
                                              click: _vm.onFieldPermissionSet
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "SystemMaintenance.FieldPermissionSettings"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    : _vm._e()
                                ]
                              : _vm._e(),
                            !_vm.isPreview &&
                            (_vm.validateRow.enableInstruction ||
                              _vm.validateRow.enableBillPayment)
                              ? [
                                  _vm.validateRow.disableCustomPage
                                    ? [
                                        _c(
                                          "span",
                                          {
                                            key: "instructionOpOffice",
                                            staticStyle: { margin: "0px 8px" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("SeaExport.opOffice")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-select",
                                          {
                                            attrs: { filterable: "" },
                                            on: {
                                              change: function($event) {
                                                return _vm.loadData()
                                              }
                                            },
                                            model: {
                                              value: _vm.branchId,
                                              callback: function($$v) {
                                                _vm.branchId = $$v
                                              },
                                              expression: "branchId"
                                            }
                                          },
                                          _vm._l(_vm.officeList, function(
                                            item,
                                            index
                                          ) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: _vm.getOfficeLabel(item),
                                                value: item.officeId
                                              }
                                            })
                                          }),
                                          1
                                        )
                                      ]
                                    : _vm._e()
                                ]
                              : _vm._e(),
                            !_vm.isPreview && _vm.pageSetBtnVisible
                              ? [
                                  _c(
                                    "el-button",
                                    {
                                      key: "pageSet",
                                      attrs: {
                                        disabled: _vm.validateRow
                                          .disableCustomPage
                                          ? false
                                          : _vm.readonly,
                                        type: "primary"
                                      },
                                      on: { click: _vm.showPageSetDialog }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "SystemMaintenance.TabSettings"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            !_vm.isPreview && _vm.validateRow.enableInstruction
                              ? [
                                  _c(
                                    "el-button",
                                    {
                                      key: "setOpInstruction",
                                      attrs: { type: "primary" },
                                      on: { click: _vm.editOpInstructionDialog }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "SystemMaintenance.SetOpInstruction"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            !_vm.isPreview && _vm.validateRow.billPaymentSetting
                              ? [
                                  _c(
                                    "el-button",
                                    {
                                      key: "paymentRequestSettings",
                                      attrs: { type: "primary" },
                                      on: {
                                        click: _vm.billPaymentSettingsHandler
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_PaymentRequestSettings"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            _vm.showBillPaymentRuleSettings
                              ? [
                                  _c(
                                    "el-button",
                                    {
                                      key: "billPaymentRuleSettings",
                                      attrs: {
                                        type: "primary",
                                        disabled: !_vm.billPaymentSetting
                                          .supervisorApproval
                                      },
                                      on: {
                                        click:
                                          _vm.billPaymentRuleSettingsHandler
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("CargoMsg.Cargo_RuleSettings")
                                        )
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            !_vm.isPreview &&
                            !_vm.validateRow.disableCustomPage &&
                            _vm.isEdit
                              ? [
                                  _vm.validateRow.pageType ===
                                  _vm.REMOTE_SEA_BOOKING_BASIC
                                    ? _c("span", [
                                        _c("i", {
                                          staticClass: "el-icon-warning",
                                          staticStyle: {
                                            color: "#e6a23c",
                                            "font-size": "14px"
                                          }
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "SystemMaintenance.TheAsThoseForConfiguration"
                                              )
                                            ) +
                                            " "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm.validateRow.pageType ===
                                  _vm.REMOTE_AIR_BOOKING_BASIC
                                    ? _c("span", [
                                        _c("i", {
                                          staticClass: "el-icon-warning",
                                          staticStyle: {
                                            color: "#e6a23c",
                                            "font-size": "14px"
                                          }
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "SystemMaintenance.TheAsTheAirConfiguration"
                                              )
                                            ) +
                                            " "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm.validateRow.pageType ===
                                    _vm.REMOTE_RE_BOOKING_BASIC ||
                                  _vm.validateRow.pageType ===
                                    _vm.REMOTE_RI_BOOKING_BASIC
                                    ? _c("span", [
                                        _c("i", {
                                          staticClass: "el-icon-warning",
                                          staticStyle: {
                                            color: "#e6a23c",
                                            "font-size": "14px"
                                          }
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "SystemMaintenance.TheThoseInTheConfiguration"
                                              )
                                            ) +
                                            " "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm.validateRow.pageType ===
                                    _vm.SEA_VERIFY_BOOKING_BASIC ||
                                  _vm.validateRow.pageType ===
                                    _vm.SEA_VERIFY_BOOKING_VESSEL
                                    ? _c("span", [
                                        _c("i", {
                                          staticClass: "el-icon-warning",
                                          staticStyle: {
                                            color: "#e6a23c",
                                            "font-size": "14px"
                                          }
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "SystemMaintenance.TheAsTheOceanConfiguration"
                                              )
                                            ) +
                                            " "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm.validateRow.pageType ===
                                  _vm.AIR_VERIFY_BOOKING_BASIC
                                    ? _c("span", [
                                        _c("i", {
                                          staticClass: "el-icon-warning",
                                          staticStyle: {
                                            color: "#e6a23c",
                                            "font-size": "14px"
                                          }
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "SystemMaintenance.TheOrderInTheConfiguration"
                                              )
                                            ) +
                                            " "
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                ]),
                _vm.validateRow
                  ? [
                      _vm.validateRow.pageType === _vm.SEA_BOOKING_BASIC
                        ? _c("sea-booking-basic", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType === _vm.SEA_BOOKING_VESSEL ||
                      _vm.validateRow.pageType === _vm.SEA_VERIFY_BOOKING_VESSEL
                        ? _c("sea-booking-vessel", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig,
                              "page-type": _vm.validateRow.pageType
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType === _vm.AIR_BOOKING_BASIC
                        ? _c("air-booking-basic", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType === _vm.AIR_BOOKING_VESSEL
                        ? _c("air-booking-vessel", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType === _vm.REMOTE_SEA_BOOKING_BASIC
                        ? _c("remote-sea-booking-basic", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType === _vm.REMOTE_AIR_BOOKING_BASIC
                        ? _c("remote-air-booking-basic", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType ===
                        _vm.REMOTE_RE_BOOKING_BASIC ||
                      _vm.validateRow.pageType === _vm.REMOTE_RI_BOOKING_BASIC
                        ? _c("remote-railway-booking-basic", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType === _vm.SEA_VERIFY_BOOKING_BASIC
                        ? _c("sea-verify-booking-basic", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType ===
                        _vm.RAILWAY_BOOKING_RE_BASIC ||
                      _vm.validateRow.pageType === _vm.RAILWAY_BOOKING_RI_BASIC
                        ? _c("railway-booking-basic", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType === _vm.AI_BOOKING_BASIC
                        ? _c("air-import-booking-basic", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType === _vm.SI_BOOKING_BASIC
                        ? _c("sea-import-booking-basic", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType === _vm.SI_BOOKING_ARRIVAL_INFO
                        ? _c("sea-import-arrival-info", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType === _vm.SEA_BOOKING_MBL
                        ? _c("sea-booking-mbl", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType === _vm.SEA_BOOKING_MBL_SPLIT ||
                      _vm.validateRow.pageType === _vm.SEA_BOOKING_MBL_MERGE
                        ? _c("sea-booking-mbl2", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType === _vm.SEA_BOOKING_HBL
                        ? _c("sea-booking-hbl", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType === _vm.SEA_BOOKING_HBL_SPLIT ||
                      _vm.validateRow.pageType === _vm.SEA_BOOKING_HBL_MERGE
                        ? _c("sea-booking-hbl2", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType === _vm.SEA_BOOKING_VIRTUAL_HBL
                        ? _c("sea-booking-virtual-hbl", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType ===
                        _vm.SEA_BOOKING_CHARGE_RECEIVABLE ||
                      _vm.validateRow.pageType ===
                        _vm.SEA_BOOKING_CHARGE_PAYABLE
                        ? _c("sea-booking-charge", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType === _vm.SEA_BOOKING_SPECIAL_GOODS
                        ? _c("sea-booking-special-goods", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType === _vm.SEA_BOOKING_CUSTOMS
                        ? _c("customs-info", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType === _vm.SEA_BOOKING_TRUCKING
                        ? _c("sea-booking-trucking", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType ===
                      _vm.SEA_BOOKING_DISCHARGING_TRUCKING
                        ? _c("sea-booking-discharging-trucking", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType === _vm.INTEGRATED_IC_BOOKING
                        ? _c("ic-booking-basic", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType ===
                      _vm.SEA_BOOKING_CONTAINER_INFO
                        ? _c("sea-booking-container", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType === _vm.INTEGRATED_CL_BOOKING
                        ? _c("cl-booking-basic", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType === _vm.INTEGRATED_TT_BOOKING
                        ? _c("tt-booking-basic", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType ===
                      _vm.SEA_BOOKING_DOMESTIC_BILLING
                        ? _c("sea-booking-internal-bill", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType === _vm.SEA_BOOKING_OVERSEA_BILL
                        ? _c("sea-booking-oversea-bill", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType === _vm.AIR_VERIFY_BOOKING_BASIC
                        ? _c("air-verify-booking-basic", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.gridTabScriptPageTypes.includes(
                        _vm.validateRow.pageType
                      )
                        ? _c("grid-tab-script", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig,
                              "hide-required": _vm.gridTabScriptHideRequire.includes(
                                _vm.validateRow.pageType
                              ),
                              "hide-alias": _vm.gridTabScriptHideAlias.includes(
                                _vm.validateRow.pageType
                              ),
                              "hide-setting": _vm.gridTabScriptHideSetting.includes(
                                _vm.validateRow.pageType
                              )
                            }
                          })
                        : _vm._e(),
                      _vm.validateRow.pageType ===
                      _vm.COMPANY_NATIVE_CUSTOMER_VENDOR_RATING
                        ? _c("company-basic", {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          })
                        : _vm._e(),
                      _vm.gridTabPageTypes.includes(_vm.validateRow.pageType)
                        ? _c(
                            "grid-tab",
                            {
                              attrs: {
                                "branch-id": _vm.branchId,
                                "is-edit": _vm.isEdit,
                                blocks: _vm.blocks,
                                "added-elements": _vm.addedElementsForEdit,
                                "is-preview": _vm.isPreview,
                                "preview-config": _vm.previewConfig,
                                "can-set-alias-function":
                                  _vm.canSetAliasFunction
                              }
                            },
                            [
                              _c("se-tab-lcl-container", {
                                attrs: {
                                  slot: "preview",
                                  context: _vm.seBookingWorkspaceContext,
                                  action: "look",
                                  "preview-config": _vm.previewConfig,
                                  "enable-ui-custom": true
                                },
                                slot: "preview"
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  : _vm._e()
              ],
              2
            )
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.saveConfirmDialog.visible,
            title:
              _vm.branchId === 1
                ? _vm.$t("SystemMaintenance.HQSavePrompt")
                : _vm.$t("SystemMaintenance.BranchSavePrompt"),
            width: "700px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.saveConfirmDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "80px" } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_ApplicationScope") + ":"
                  }
                },
                [
                  _c(
                    "el-radio",
                    {
                      staticStyle: { "white-space": "normal" },
                      attrs: { label: 0 },
                      model: {
                        value: _vm.saveConfirmDialog.applyRange,
                        callback: function($$v) {
                          _vm.$set(_vm.saveConfirmDialog, "applyRange", $$v)
                        },
                        expression: "saveConfirmDialog.applyRange"
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.branchId === 1
                              ? _vm.$t(
                                  "SystemMaintenance.OnlyDisplayMandatoryRule"
                                )
                              : _vm.$t(
                                  "SystemMaintenance.OfficeOnlyDisplayMandatoryRule"
                                )
                          ) +
                          " "
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: " " } },
                [
                  _c(
                    "el-radio",
                    {
                      staticStyle: { "white-space": "normal" },
                      attrs: { label: 1 },
                      model: {
                        value: _vm.saveConfirmDialog.applyRange,
                        callback: function($$v) {
                          _vm.$set(_vm.saveConfirmDialog, "applyRange", $$v)
                        },
                        expression: "saveConfirmDialog.applyRange"
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.branchId === 1
                              ? _vm.$t("SystemMaintenance.DisplayMandatorySort")
                              : _vm.$t(
                                  "SystemMaintenance.OfficeDisplayMandatorySort"
                                )
                          ) +
                          " "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm.saveConfirmDialog.applyRange === 1
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-top": "-10px" },
                      attrs: { label: " " }
                    },
                    [
                      _c("span", [
                        _c("i", {
                          staticClass: "el-icon-warning",
                          staticStyle: { color: "#e6a23c" }
                        }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.branchId === 1
                                ? _vm.$t("SystemMaintenance.AdjustOrderConfig")
                                : _vm.$t(
                                    "SystemMaintenance.OfficeAdjustOrderConfig"
                                  )
                            ) +
                            " "
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.doSave } },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.saveConfirmDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("instruction-set-dialog", {
        attrs: {
          visible: _vm.instructionSetDialog.visible,
          module: _vm.instructionSetDialog.module,
          "page-type": _vm.instructionSetDialog.pageType,
          "branch-id": _vm.branchId,
          lob: _vm.instructionSetDialog.lob,
          "tenant-instructions":
            _vm.instructionSetDialog.availableTenantInstructions,
          "specific-business-rules": _vm.specificBusinessRules,
          "use-hq-set": _vm.useHqSet,
          readonly: false
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.instructionSetDialog, "visible", $event)
          }
        }
      }),
      _c("field-permission-set-dialog", {
        attrs: {
          visible: _vm.fieldPermissionSetDialog.visible,
          "page-type": _vm.fieldPermissionSetDialog.pageType,
          "page-name": _vm.fieldPermissionSetDialog.pageName,
          lob: _vm.fieldPermissionSetDialog.lob,
          "branch-id": _vm.branchId,
          blocks: _vm.blocks
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.fieldPermissionSetDialog, "visible", $event)
          },
          updateCallback: _vm.onFieldPermissionSetUpdateCallback
        }
      }),
      _c("page-set-dialog", {
        attrs: {
          visible: _vm.pageSetDialog.visible,
          "page-type": _vm.pageSetDialog.pageType
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.pageSetDialog, "visible", $event)
          }
        }
      }),
      _c("value-sync-set-dialog", {
        attrs: {
          visible: _vm.valueSyncSetDialog.visible,
          module: _vm.valueSyncSetDialog.module,
          "branch-id": _vm.branchId
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.valueSyncSetDialog, "visible", $event)
          }
        }
      }),
      _c("bill-payment-setting-dialog", {
        attrs: {
          visible: _vm.billPaymentSetDialog.visible,
          "page-type": _vm.billPaymentSetDialog.pageType,
          "branch-id": _vm.branchId,
          lob: _vm.billPaymentSetDialog.lob,
          readonly: false
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billPaymentSetDialog, "visible", $event)
          }
        }
      }),
      _c("bill-payment-rule-setting-dialog", {
        attrs: {
          visible: _vm.billPaymentRuleSetDialog.visible,
          "page-type": _vm.billPaymentRuleSetDialog.pageType,
          "branch-id": _vm.branchId,
          lob: _vm.billPaymentRuleSetDialog.lob,
          "specific-business-rules": _vm.specificBusinessRules,
          readonly: false
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billPaymentRuleSetDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }